@use '@/styles/tokens' as *;

// Figma node 219:327388 — a 16:10 satellite frame with the crop chip top-left, the crop year
// top-right, and the field/place row on a cream band beneath.

.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.title {
  margin: 0;
  font-family: $font-family-heading;
  font-size: $font-size-20;
  font-weight: $font-weight-medium;
  line-height: 1.2;
  color: var(--text-primary);
}

.frame {
  overflow: hidden;
  border-radius: $radius-xl;
  background: var(--surface-card);
}

.mapWrap {
  position: relative;
  aspect-ratio: 16 / 10;
}

.map {
  width: 100%;
  height: 100%;
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 16 / 10;
  background: $color-neutral-100;
}

.emptyText {
  margin: 0;
  padding-inline: var(--space-5);
  font-size: $font-size-14;
  line-height: 1.4;
  color: var(--text-muted);
  text-align: center;
}

// A white ring around a red dot, matching the design's marker.
.pin {
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  border: 3px solid var(--surface-card);
  border-radius: 50%;
  background: $color-error-700;
  box-shadow: var(--shadow-md);
}

.pinIcon {
  color: var(--text-inverse);
}

.crop {
  position: absolute;
  top: var(--space-3);
  left: var(--space-3);
}

.cropYear {
  position: absolute;
  top: var(--space-3);
  right: var(--space-3);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  text-align: right;
}

.cropYearLabel {
  font-size: $font-size-11;
  line-height: 1.2;
  color: rgba(255, 255, 255, 0.8);
}

.cropYearValue {
  font-size: $font-size-13;
  font-weight: $font-weight-medium;
  line-height: 1.2;
  color: var(--text-inverse);
}

.meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: var(--space-4);
  background: $color-accent2-100;
}

.fieldName {
  margin: 0;
  font-size: $font-size-16;
  font-weight: $font-weight-medium;
  line-height: 1.3;
  color: var(--text-primary);
}

.place {
  margin: 0;
  font-size: $font-size-13;
  line-height: 1.3;
  color: var(--text-tertiary);
}
